import { render, staticRenderFns } from "./PhoneStepDetail.vue?vue&type=template&id=65e2194e&scoped=true"
import script from "./PhoneStepDetail.vue?vue&type=script&lang=js"
export * from "./PhoneStepDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e2194e",
  null
  
)

export default component.exports